// extracted by mini-css-extract-plugin
module.exports = {"f1c61u8i":"f1c61u8i"};